import { createAction, props } from '@ngrx/store';
import { BoardSummary } from 'app/trello/models/board-summary';
import { DateRange } from 'app/trello/models/date-range';
import { Label } from 'app/trello/models/labels';
import { List } from 'app/trello/models/lists';
import { Member } from 'app/trello/models/members';

// ------------------------------------------------------

export const boardSummaryReportOpened = createAction(
  '[Board Summary Report] Opened',
  props<{ now: string }>(),
);

export const boardSummaryReportDateRangeSelected = createAction(
  '[Board Summary Report] Date Range Selected',
  props<{ dateRange: DateRange, now: string }>(),
);

// ------------------------------------------------------

export const loadBoardSummaryStatistics = createAction(
  '[Board Summary Statistics] Load',
  props<{ dateRange: DateRange, now: string }>(),
);

export const loadBoardSummaryStatisticsSuccess = createAction(
  '[Board Summary Statistics] Load Success',
  props<{ boardSummary: BoardSummary, dateRange: DateRange, now: string }>(),
);

export const loadBoardSummaryStatisticsFailure = createAction(
  '[Board Summary Statistics] Load Failure',
  props<{ error: string }>(),
);

// ------------------------------------------------------

export const loadComparableBoardSummaryStatistics = createAction(
  '[Board Summary Statistics] Load Comparable',
  props<{ comparableDateRange: DateRange, now: string }>(),
);

export const loadComparableBoardSummaryStatisticsSuccess = createAction(
  '[Board Summary Statistics] Load Comparable Success',
  props<{ comparableBoardSummary: BoardSummary, comparableDateRange: DateRange, now: string }>(),
);

export const loadComparableBoardSummaryStatisticsFailure = createAction(
  '[Board Summary Statistics] Load Comparable Failure',
  props<{ error: string }>(),
);

// ------------------------------------------------------

export const loadLabels = createAction(
  '[Labels] Load',
  props<{ now: string }>(),
);

export const loadLabelsSuccess = createAction(
  '[Labels] Load Labels Success',
  props<{ labels: Label[], now: string }>(),
);

export const loadLabelsFailure = createAction(
  '[Labels] Load Labels Failure',
  props<{ error: string }>(),
);

// ------------------------------------------------------

export const loadLists = createAction(
  '[Lists] Load',
  props<{ now: string }>(),
);

export const loadListsSuccess = createAction(
  '[Lists] Load Lists Success',
  props<{ lists: List[], now: string }>(),
);

export const loadListsFailure = createAction(
  '[Lists] Load Lists Failure',
  props<{ error: string }>(),
);

// ------------------------------------------------------

export const loadMembers = createAction(
  '[Members] Load',
  props<{ now: string }>(),
);

export const loadMembersSuccess = createAction(
  '[Members] Load Members Success',
  props<{ members: Member[], now: string }>(),
);

export const loadMembersFailure = createAction(
  '[Members] Load Members Failure',
  props<{ error: string }>(),
);

// ------------------------------------------------------
